import { useState, useCallback } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export function useFeatureAccess() {
  const [upgradeModal, setUpgradeModal] = useState({
    isOpen: false,
    feature: null,
    currentPlan: null,
    availablePlans: [],
    role: null
  });

  const checkFeature = useCallback(async (feature, onSuccess) => {
    try {
      const response = await axios.get(`${API}/subscription/check-feature?feature=${feature}`);
      
      if (response.data.allowed) {
        if (onSuccess) onSuccess();
        return true;
      } else {
        const upgradeInfo = response.data.upgrade_info || {};
        setUpgradeModal({
          isOpen: true,
          feature: feature,
          currentPlan: upgradeInfo.current_plan_name || 'Free',
          requiredPlan: upgradeInfo.required_plan_name || 'Pro',
          requiredPriceMonthly: upgradeInfo.required_price_usd_monthly,
          requiredPriceYearly: upgradeInfo.required_price_usd_yearly,
          availablePlans: [],
          role: null
        });
        return false;
      }
    } catch (error) {
      console.error('Error checking feature access:', error);
      // If check fails, allow access (fail open for MVP)
      if (onSuccess) onSuccess();
      return true;
    }
  }, []);

  const closeUpgradeModal = useCallback(() => {
    setUpgradeModal({
      isOpen: false,
      feature: null,
      currentPlan: null,
      availablePlans: [],
      role: null
    });
  }, []);

  return {
    upgradeModal,
    checkFeature,
    closeUpgradeModal
  };
}
